<template>
    <div class="page-container flex flex-sub">
        <div class="flex flex-direction flex-sub">
            <div class="reason-container flex flex-direction padding-xs">
                <div class="text-black text-df text-bold self-center">附件</div>
                <div v-for="(item,index) in files"
                     :key="index" class="record-item flex align-center justify-between margin-top-xs padding-xs">
                    <div :href="item.file_url" class="file-name title text-sm" target="_blank" @click="toFilePreview(item.file_name,item.file_url)">{{ item.file_name }}</div>
                    <el-button v-if="!readonly" class="el-icon-delete text-orange" type="text" @click="delFile(item,index)"></el-button>
                </div>
                <el-empty v-if="!files.length" image-size="100"></el-empty>
                <upload-file :disabled="readonly" @uploadFile="uploadFile">
                    <el-button slot="upload" class="btn small radius" size="small" type="primary" >上传</el-button>
                </upload-file>
            </div>
        </div>
        <div class="flex flex-direction margin-lr-sm flex-shrink padding-sm"
             style="width: 23.8cm; box-shadow: 0 2px 8px 0 hsla(0, 0%, 0%, .1);"
             v-if="readonly">
            <div class="text-black text-lg text-bold margin-tb-xs">{{ title }}</div>
            <el-divider></el-divider>
            <div class="detail" v-html="content"></div>
        </div>
        <ck-decoupled-editor ref="editor" :content="content" :title="title" class="margin-lr-sm flex-shrink" v-else></ck-decoupled-editor>
        <div class="flex flex-direction flex-sub">
            <el-button v-if="!readonly" :loading="requesting" class="bg-orange radius" type="warning" @click="submitInfo()">
                保存
            </el-button>
        </div>
    </div>
</template>

<script>

import {confirm, toast, TOAST, toFilePreview} from "@/utils/utils";
import CkDecoupledEditor from "@/views/web/components/CKDecoupledEditor";
import {addPostSummary, getPostSummary} from "@/api";
import UploadFile from "@/views/web/components/UploadFile";

export default {
    components: {UploadFile, CkDecoupledEditor},
    name: "PostSummary",
    data() {
        return {
            title: '',
            content: '',
            files: [],
            requesting: false
        }
    },
    props: {
        pid: {
            type: Number,
            default: 0
        },
        type: {//1总结记录2委托方意见
            type: Number,
            default: 1
        },
        readonly: {
            type: Boolean,
            default: false
        },
    },
    computed: {},
    created() {
        if (this.pid) this.init()
    },
    methods: {
        async init() {
            let _data = await getPostSummary(this.pid, this.type)
            if (_data.data.comments) {
                this.title = _data.data.comments.title
                this.content = _data.data.comments.content
                this.files = _data.data.comments.file
            }
        },
        async submitInfo() {
            let _info = this.$refs.editor.getInfo()
            if (!_info.content) return toast('请输入内容', TOAST.error)
            this.requesting = true
            let _data = await addPostSummary(this.pid, _info.title, _info.content, JSON.stringify(this.files), this.type)
            this.requesting = false
            if (_data.status === 200) {
                this.init()
                toast(`保存成功`, TOAST.success)
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        delFile(item, index) {
            confirm(`删除文件`, `你确定删除<b>${item.file_name}</b>文件吗？`, () => {
                this.files.splice(index, 1)
            }, '确认', true)
        },
        //  上传成功
        uploadFile(data) {
            this.uping.close();
            this.files.push({
                file_name: data.file.name,
                file_url: data.file.url
            })
        },
        toFilePreview(name,url){
            toFilePreview(name,url)
        }
    },
    filters: {},
    watch: {
        pid() {
            if (this.pid) {
                this.init()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.page-container {
    .status {
        padding: 12px 24px;
    }
    .reason-container {
        width: 350px;
        background-color: #f9f9f9;
        border-radius: 10px;
        border: solid 1px #ececec;

        .record-item {
            background-color: #ffffff;
            border-radius: 10px;
            border: solid 1px #ececec;
        }
    }
}
</style>